import * as React from "react";
// import './voteStyle.css'

interface IProps {
  qs: any;
}

export default class ResultComponent extends React.Component<IProps, any> {
  public render() {
    const { qs } = this.props;
    console.log("qs:++++>>>", qs);
    return (
      <div>
        {qs.questionStatistics.map((e: any, c: number) => {
          return (
            <div key={c} className="vote__detailed--group">
              <div className="vote__detailed--title">
                <h2 className="vote__detailed--title">
                  {e.question}
                  <span className="vote__detailed--type">
                    ({e.maxNumberChoice === 1 ? `单选` : `最多选${e.maxNumberChoice}项`})
                  </span>
                </h2>
              </div>
              {e.answerStatistics.map((k: any, i: number) => {
                const proportion = (k.count / e.count) * 100;
                const w: any = proportion.toFixed(2);
                return (
                  <div key={i} className="vote__detailed--group--content">
                    <div className="vote__detailed--group-item">
                      <div className="vote__detailed--group-item-answer">
                        {i + 1}、{k.content}
                      </div>
                      <div className="vote__detailed--group-item--content">
                        <div className="vote__detailed--group-item-bar">
                          <span style={{ width: `${w}%`, height: "100%" }} />
                        </div>
                        <div className="vote__detailed--group-item-count">
                          <span>{k.count}票</span>
                          <span>{w}%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/vote/component/result.tsx